import { Button, Col, Divider, Modal, Popover, Row } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { COLORS } from '../constants/Colors';
import Typography from './Typography';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import MyButton from './Button';
import React, { useRef, useState } from 'react';
import _ from 'lodash';
import './Customer.css';
import { FormattedMessage } from 'react-intl';

export const CustomerListItem = (props) => {
  const isDesktop = useIsDesktop();

  const {
    customer,
    onClickView,
    isHideAction,
    onClickEdit,
    onClickDelete,
    contactData,
    contactSearch,
    onCreateCustomer,
    visible,
    setVisible,
    profile,
  } = props;
  const { customerContactName, customerContactPhone, customerContactEmail, remark } = customer;
  const name = _.size(customerContactName) > 0 ? customerContactName : contactSearch;
  const phone = customerContactPhone;
  const email = customerContactEmail;
  const [visiblePopover, setVisiblePopover] = useState(null);
  const [offsetPopover, setOffsetPopover] = useState({ left: 0, top: 0 });
  const [visiblePop, setVisiblePop] = useState(false);
  const ref = useRef();

  const handleDivClick = (event) => {
    const { clientX, clientY } = event;
    const xOffset = -25;
    const yOffset = -25;
    if (
      offsetPopover.left !== clientX + xOffset ||
      offsetPopover.top !== clientY + yOffset
    ) {
    setOffsetPopover({ left: clientX + xOffset, top: clientY + yOffset });
    }
  };

  const handleItemClick = (itemId) => {
    setVisiblePopover(itemId);
  };

  // const PopoverContent = visiblePopover === _.get(customer, 'customerContactId') && (
    const PopoverContent = (
    <div>
      <div>
        <Button
          className='customer-button'
          style={{ width: '100%' }}
          type='text'
          onClick={() => {
            onClickView();
            setVisiblePopover(null);
            setOffsetPopover({ left: 0, top: 0 })
          }}
        >
          <Typography>
            <FormattedMessage id='btnView' defaultMessage='View' />
          </Typography>
        </Button>
      </div>
      <div>
        <Button
          className='customer-button'
          style={{ width: '100%' }}
          type='text'
          onClick={() => {
            onClickDelete();
            setVisiblePopover(null);
            setOffsetPopover({ left: 0, top: 0 })
          }}
        >
          <Typography>
            <FormattedMessage id='btnDelete' defaultMessage='Delete' />
          </Typography>
        </Button>
      </div>
    </div>
  );

  const handleVisibleChange = (newVisible) => {
    setVisiblePop(newVisible);
  };

  return (
    <div>
      {isHideAction ? (
        <Row
          className='w-100'
          style={
            profile
              ? null
              : {
                  padding: '20px',
                  // ... other styles
                }
          }
        >
          <Col span={isDesktop ? 6 : 24}>
            <Typography isBold style={isDesktop ? null : { marginBottom: '8px' }}>
              {name}
            </Typography>
          </Col>
          <Col span={isDesktop ? 8 : 24}>
            <Typography style={isDesktop ? null : { marginBottom: '8px' }}>
              {phone}
              {phone && email ? ',' : null}
              {email}
            </Typography>
          </Col>
          {isDesktop && (
            <Col span={8}>
              <Typography style={isDesktop ? null : { marginBottom: '8px' }}>{remark}</Typography>
            </Col>
          )}
        </Row>
      ) : _.size(contactData) === 0 ? (
        <div
          ref={ref}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            onCreateCustomer(contactSearch);
            setVisiblePopover(null);
          }}
        >
          <Row
            className='w-100'
            style={
              profile
                ? null
                : {
                    padding: '20px',
                    // ... other styles
                  }
            }
          >
            <Col span={isDesktop ? 6 : 24}>
              <Typography isBold>{name}</Typography>
            </Col>
            <Col span={isDesktop ? 8 : 24}>
              <Typography>
                {phone}
                {phone && email ? ',' : null}
                {email}
              </Typography>
            </Col>
            {isDesktop && (
              <Col span={8}>
                <Typography>{remark}</Typography>
              </Col>
            )}
          </Row>
        </div>
      ) : (
        <Popover
          // placement='left'
          // content={PopoverContent}
          // trigger='click'
          // zIndex={999}
          // overlayStyle={visiblePopover ? { position: 'fixed', left: offsetPopover.left, top: offsetPopover.top } : {display: 'none'}}
          // destroyTooltipOnHide={true}
          // visible={visiblePop}
          // onVisibleChange={handleVisibleChange}
          placement="left"
          content={PopoverContent}
          overlayStyle={{
            position: "fixed",
            left: offsetPopover.left,
            top: offsetPopover.top,
            maxWidth: "300px", // กำหนดขนาดสูงสุด
            width: "fit-content", // ใช้ขนาดตามเนื้อหา
            overflow: "hidden", // ป้องกัน overflow
          }}
          // overlayStyle={stylePop}
          // onClick={() => handleItemClick(_.get(customer, 'customerContactId'))}
          onClick={(e) => {
            handleDivClick(e);
            handleItemClick(_.get(customer, 'customerContactId'));
          }}
          zIndex={999}
          trigger="click"
          destroyTooltipOnHide={true}
        >
          <div
            // onClick={(e) => {
            //   handleDivClick(e);
            //   handleItemClick(_.get(customer, 'customerContactId'));
            // }}
          >
            <Row
              className='w-100'
              style={
                profile
                  ? null
                  : {
                      padding: '20px',
                      // ... other styles
                    }
              }
            >
              <Col span={isDesktop ? 6 : 24}>
                <Typography isBold>{name}</Typography>
              </Col>
              <Col span={isDesktop ? 8 : 24}>
                <Typography>
                  {phone}
                  {phone && email ? ',' : null}
                  {email}
                </Typography>
              </Col>
              {isDesktop && (
                <Col span={8}>
                  <Typography>{remark}</Typography>
                </Col>
              )}
            </Row>
          </div>
          <div style={{ width: 0, height: 0 }} ref={ref}></div>
        </Popover>
      )}
    </div>
  );
};

const CustomerList = (props) => {
  const {
    onCreateCustomer,
    onClickCustomer,
    onClickEditCustomer,
    contactData,
    contactSearch,
    onClickDelete,
    isOpen,
    setIsOpen,
    visible,
    setVisible,
  } = props;
  const isDesktop = useIsDesktop();

  const [id, setId] = useState('');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '8px',
        backgroundColor: 'white',
        width: '100%',
        cursor: 'pointer',
        height: isDesktop ? "calc(100vh - 278px)" : undefined,
      }}
    >
      <Modal
        open={isOpen}
        onOk={() => onClickDelete(id)}
        onCancel={() => {
          setIsOpen(false);
        }}
        centered
        className='custom-modal'
        bodyStyle={{ overflow: 'hidden', height: '100px' }}
        style={{ marginTop: isDesktop ? '150px' : '270px', maxWidth: '350px', marginBottom: '150px' }}
        footer={[
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <MyButton
              onClick={() => {
                setIsOpen(false);
              }}
              style={{
                width: isDesktop ? '25%' : '30%',
                marginLeft: '0px',
                marginTop: '0px',
                marginRight: '5px',
              }}
            >
              <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
            </MyButton>{' '}
            <MyButton
              isPrimary
              onClick={() => onClickDelete(id)}
              style={{
                width: isDesktop ? '25%' : '30%',
                marginInlineStart: '0px',
              }}
            >
              <FormattedMessage id='btnOK' defaultMessage='Ok' />
            </MyButton>
          </div>,
        ]}
      >
        <div style={{ height: '100px' }}>
          <Typography isBold size='16px' color={COLORS.Primary} className='text-center p-2'>
            <FormattedMessage id='confirmModalDelete' defaultMessage='Confirm delete' />
          </Typography>
          <Typography className='text-center p-3'>
            <FormattedMessage id='confirmDeleteCustomer' defaultMessage='Do you want to delete customer ?' />
          </Typography>
        </div>
      </Modal>
      <div className='d-flex flex-column justify-content-center text-left w-100'>
        <div className='py-3 px-4 d-flex align-items-center justify-content-between'>
          <Typography isBold color={COLORS.Primary}>
            <FormattedMessage id='labelCustomer' defaultMessage='Customer' />
          </Typography>
          <MyButton bgColor={COLORS.Primary} isPrimary onClick={onCreateCustomer}>
            <span>
              <PlusOutlined /> {isDesktop ? <FormattedMessage id='btnCreate' defaultMessage='Create' /> : ''}
            </span>
          </MyButton>
        </div>
        <Divider className='m-0' />
        <div style={{ height: 'calc(100vh - 380px)', overflowY: 'auto' }}>
          {_.size(contactData) > 0 ? (
            contactData.map((element, index) => {
              return (
                <>
                  {index !== 0 && <Divider style={{ margin: '0px' }} />}
                  <CustomerListItem
                    customer={element}
                    onClickView={() => onClickCustomer(element)}
                    onClickEdit={onClickEditCustomer}
                    onClickDelete={() => {
                      setId(element);
                      setIsOpen(true);
                      setVisible(false);
                    }}
                    contactData={contactData}
                    visible={visible}
                    setVisible={setVisible}
                  />
                </>
              );
            })
          ) : (
            <>
              <CustomerListItem
                customer={contactSearch}
                onClickEdit={onClickEditCustomer}
                onClickDelete={() => {
                  setIsOpen(true);
                }}
                onCreateCustomer={onCreateCustomer}
                contactSearch={contactSearch}
                visible={visible}
                setVisible={setVisible}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerList;
